import React from 'react';
import { useNavigate } from 'react-router-dom';
export default function StripTitle(props) {
    var page = props.page, fields = props.fields;
    var displayTitle = fields.displayTitle, content = fields.content, link = fields.link, linkLabel = fields.linkLabel, showPrevPageLink = fields.showPrevPageLink, headlineStyle = fields.headlineStyle;
    var navigate = useNavigate();
    var TitleTag = (fields.titleTag || 'h1');
    var navigateToParentUrl = function () {
        if (page && page.parentUrl) {
            if (page.parentUrl[0] == '/') {
                event && event.preventDefault();
                navigate(page.parentUrl);
            }
            else {
                window.location.href = page.parentUrl;
            }
        }
    };
    var getNavTitle = function () {
        if (page && page.navTitle) {
            return page.navTitle;
        }
        else {
            return fields.name;
        }
    };
    return (React.createElement("div", { className: "strip spa-strip-title " +
            fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") },
        React.createElement("div", { className: "container" },
            headlineStyle === 'Headline Style 1 - With Slash' && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-4" },
                        React.createElement("div", { className: "d-flex content-title flex-wrap" },
                            showPrevPageLink && page && page.parentNavTitle &&
                                React.createElement("div", { className: "back-btn" },
                                    React.createElement("button", { className: "btn-back p-2 border-0 text-medium bg-white", onClick: navigateToParentUrl },
                                        React.createElement("i", { className: "fa-solid fa-arrow-left me-2" }),
                                        page.parentNavTitle)),
                            displayTitle && (React.createElement(TitleTag, { className: fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: displayTitle } })))),
                    React.createElement("div", { className: "col-lg-1 d-none d-lg-flex position-relative" },
                        React.createElement("div", { className: "divider" }, " "))),
                React.createElement("div", { className: "row mt-lg-n3" },
                    React.createElement("div", { className: "col-lg-6 offset-lg-6" },
                        React.createElement("div", { className: "content" },
                            content && React.createElement("div", { dangerouslySetInnerHTML: { __html: content } }),
                            link && linkLabel && (React.createElement("div", { className: "btn-bottom mt-4" },
                                React.createElement("a", { href: link, className: "btn btn-primary" }, linkLabel)))))))),
            headlineStyle === 'Headline Style 2 - With Page name/Back Link' && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-lg-2" },
                    React.createElement("div", { className: "d-flex" },
                        showPrevPageLink && page && page.parentNavTitle ? (React.createElement("div", { className: "back-btn" },
                            React.createElement("button", { className: "btn-back p-2 border-0 text-medium bg-white", onClick: navigateToParentUrl },
                                React.createElement("i", { className: "fa-solid fa-arrow-left me-2" }),
                                page.parentNavTitle))) : (React.createElement("div", { className: "small-title" }, getNavTitle())),
                        React.createElement("div", { className: "divider with-back d-none d-lg-block" }, " "))),
                React.createElement("div", { className: "col-lg-7 offset-lg-3" },
                    displayTitle && (React.createElement(TitleTag, { className: fields.titleStyle + " mb-4", itemProp: "name", dangerouslySetInnerHTML: { __html: displayTitle } })),
                    content && React.createElement("div", { className: "pb-4", dangerouslySetInnerHTML: { __html: content } }),
                    link && linkLabel && (React.createElement("div", { className: "btn-bottom mt-4" },
                        React.createElement("a", { href: link, className: "btn btn-primary mt-2" }, linkLabel)))))),
            headlineStyle === 'Headline Style 3 - Without Slash' && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    showPrevPageLink && page && page.parentNavTitle &&
                        React.createElement("div", { className: "back-btn" },
                            React.createElement("button", { className: "btn-back p-2 border-0 text-medium bg-white", onClick: navigateToParentUrl },
                                React.createElement("i", { className: "fa-solid fa-arrow-left me-2" }),
                                page.parentNavTitle)),
                    displayTitle && (React.createElement(TitleTag, { className: fields.titleStyle + " mb-4", itemProp: "name", dangerouslySetInnerHTML: { __html: displayTitle } })),
                    content && React.createElement("div", { dangerouslySetInnerHTML: { __html: content } }),
                    link && linkLabel && (React.createElement("div", { className: "btn-bottom mt-4" },
                        React.createElement("a", { href: link, className: "btn btn-primary" }, linkLabel)))))))));
}
